import React from 'react'
import { useTranslation } from 'react-i18next'
import CopyButton from '../components/CopyButton';
import NextSectionCard from '../components/NextSectionCard';
import { timeSince } from '../utils/timeSince';
import PreviousSectionCard from '../components/PreviousSectionCard';
import tutorialIcon from "../assets/icons/tutorial.svg";

const ConfigGopaperlessAgent = () => {
    const { t, i18n } = useTranslation();
    const lastUpdated = "2025-12-05";
    const lang = i18n.language;

    const buildCopyText = (t) => {
        return "";
    }
    return (
        <div className="text-black dark:text-white">
            <div
                className="
          desktop:px-4
          py-3
          max-w-3xl
        "
            >
                <div className="relative flex items-center justify-between gap-3">
                    <div className="flex items-center gap-1">
                        <div>
                            <img src={tutorialIcon} alt="tutorial" className="w-6 h-6" />
                        </div>
                        <div>
                            <p className="text-[16px] tabletpro:text-[14px] mini_mobile:text-[14px] text-[#0087FE] font-normal">
                                {t("sidebar.usage.title").toUpperCase()}
                            </p>
                        </div>
                    </div>

                    <CopyButton text={buildCopyText(t)} />
                </div>

                <div className="mt-2 relative">
                    <section className='flex gap-4'>
                        <p className='text-[#020617] dark:text-[#F8FAFC] text-[40px] tabletpro:text-[22px] mobile:text-[30px] mini_mobile:text-[24px] font-semibold'>{t("sidebar.usage.config")}</p>
                    </section>

                    <section className='flex gap-4 mt-1'>
                        <p className='text-[16px] font-normal  text-[#0F172A] dark:text-[#F1F5F9]'>{t("common.comingsoon")}</p>
                    </section>

                    <section className='flex gap-4 mt-4 flex-col desktop:flex-row'>
                        <PreviousSectionCard
                            label={t("sidebar.usage.title")}
                            to="/userguide"
                        />
                        <NextSectionCard
                            label={t("sidebar.usage.login")}
                            to="/login-gopaperlessagent"
                        />
                    </section>

                    {/* Last updated */}
                    <section className='flex gap-4 mt-4'>
                        <span className="text-[14px] text-[#64748B]">
                            {t("welcome.lastUpdatedBase")} {timeSince(lastUpdated, lang)}
                        </span>
                    </section>
                </div>

            </div>
        </div>

    )
}

export default ConfigGopaperlessAgent
